import React from 'react';

export default class TestReactModal extends React.Component<any, null> {
  static setAppElement() {
    // it is necessary for the mock to respond to this function
  }

  render() {
    return (
      <div id={this.props.id}>
        {this.props.isOpen && this.props.children}
      </div>
    );
  }
}
